/** User preference: draft quest editor autosaves after edits (default off). */
export const QUEST_EDITOR_AUTOSAVE_STORAGE_KEY = "mapus.questEditorAutosave";

export function readQuestEditorAutosavePref(): boolean {
  try {
    return localStorage.getItem(QUEST_EDITOR_AUTOSAVE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeQuestEditorAutosavePref(enabled: boolean): void {
  try {
    localStorage.setItem(QUEST_EDITOR_AUTOSAVE_STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* private mode */
  }
}
